import React, { useContext } from "react";
import IllustrationOne from "../../../../assets/images/trueCloud/illustration-1.svg";
import IllustrationTwo from "../../../../assets/images/trueCloud/illustration-2.svg";
import IllustrationThree from "../../../../assets/images/trueCloud/illustration-3.svg";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import useSWR from "swr";
import DownloadSection from "../../../../lib/downloadSection";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";
import { CloudFeaturesGrid } from "./CloudFeaturesGrid";
import { CloudSubscriptionSection } from "./CloudSubscriptionSection";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";

const PAGE_X = "px-6 lg:px-[120px]";

export const TrueCloudContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher,
  );
  const { isLoggedIn } = useContext(LoginContext);

  const features = [
    {
      image: IllustrationOne,
      label: "Seamless Remote Control from Anywhere",
      imageLeft: true,
      sectionBg: "#f8f8f8",
      textAlign: "left",
      bodyColor: "#3b3b3b",
      imageMaxWidth: "306px",
      description:
        "Our cloud-based management platform delivers complete control over your building security from anywhere, accessible via any smart or mobile device. True Cloud enables seamless management of single or multiple sites from a unified platform.",
    },
    {
      image: IllustrationTwo,
      label: "Full Control, Anywhere, Anytime",
      imageLeft: false,
      sectionBg: "#ffffff",
      textAlign: "right",
      bodyColor: "#5b5b5b",
      imageMaxWidth: "428px",
      description: (
        <>
          <p className="mb-0">
            The key to this design is the systems administrator&apos;s ability to
            have 100% control of the platform locally as well as through the
            cloud.
          </p>
          <p>
            If the cloud is not accessible, the administrator has local control
            to manage and make changes. Both approaches provide seamless
            management of single or multiple sites as a unified platform.
          </p>
        </>
      ),
    },
    {
      image: IllustrationThree,
      label: "Powered by AWS for Ultimate Security",
      imageLeft: true,
      sectionBg: "#f8f8f8",
      textAlign: "left",
      bodyColor: "#3b3b3b",
      imageMaxWidth: "476px",
      description:
        "Leveraging AWS Cloud services, it incorporates the latest security scanning protocols and enables rapid remote deployment of updates.",
    },
  ];

  return (
    <>
      {/* Hero */}
      <section
        className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
          True Cloud Security Management
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[872px]">
          Securely manage single or multi-site access control systems from
          anywhere with a cloud-native platform built for scalability,
          reliability, and seamless remote operations.
        </p>
      </section>



      {/* Feature Sections */}
      <div className="w-full bg-white mt-6">
        {features.map((feature) => (
          <SectionBlock
            key={feature.label}
            image={feature.image}
            label={feature.label}
            description={feature.description}
            imageLeft={feature.imageLeft}
            sectionBg={feature.sectionBg}
            textAlign={feature.textAlign}
            bodyColor={feature.bodyColor}
            imageMaxWidth={feature.imageMaxWidth}
          />
        ))}
      </div>

      <CloudFeaturesGrid />

      {/* Our Core Focus */}
      <section className={`bg-[#f8f8f8] ${PAGE_X} py-[60px]`}>
        <div className="max-w-[1202px] mx-auto flex flex-col items-center gap-4 text-center">
          <h2 className="text-[#5b5b5b] text-[32px] font-medium font-['Inter'] leading-normal w-full">
            Our core focus
          </h2>
          <p className="text-[#5b5b5b] text-base font-normal font-['Poppins'] leading-[26px] w-full">
            Simplicity, Ease of use, and the Convergence of multiple technologies
            within a Single, Unified Platform
          </p>
        </div>
      </section>

      <CloudSubscriptionSection />
      {isLoggedIn && (
        <div className={`mx-auto pb-0`}>
          <DownloadSection
            title="Cut Sheet"
            description="Learn about 2.0 True Cloud features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="1-dmpl"
            showOnlyFirst={true}
          />
        </div>
      )}
    </>
  );
};